import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import _ from 'lodash';

import Avatar from './Avatar';

class Assignee extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAddUser: false,
    };

    this.handleAddUser = this.handleAddUser.bind(this);
    this.toggleAddUser = this.toggleAddUser.bind(this);
  }

  toggleAddUser() {
    this.setState({ showAddUser: !this.state.showAddUser });
  }

  handleAddUser(obj, ...rest) {
    const newObj = {
      ...obj,
    };
    delete (newObj.label);
    const { assignee = [], update } = this.props;
    const newAssignee = assignee.slice();
    newAssignee.push(newObj);
    update(_.uniqBy(newAssignee, a => a.username), ...rest);
    this.toggleAddUser();
  }

  render() {
    const { assignee = [], assignableUsers = [] } = this.props;
    const { showAddUser = false } = this.state;

    const assigneeUsernames = _.map(assignee, a => a.username);
    const unusedAssignableUsers = _.filter(assignableUsers, a => !assigneeUsernames.includes(a.username));
    const options = _.map(unusedAssignableUsers, a => ({
      ...a,
      label: `${a.firstname} ${a.lastname}`,
      value: a.username,
    }));

    return (
      <div className='assignee'>
        {_.map(assignee, a => <Avatar key={a.username} className='user' user={a} />)}
        {!showAddUser ?
          <span
            className='icon'
            role='button'
            tabIndex={-1}
            onClick={this.toggleAddUser}
          >
            <i className='fas fa-plus' />
          </span> : null
        }
        {showAddUser ?
          <Select
            options={options}
            onChange={this.handleAddUser}
            style={{ zIndex: 99999, position: 'absolute' }}
          /> : null
        }
      </div>
    );
  }
}

Assignee.propTypes = {
  assignee: PropTypes.instanceOf(Array),
  assignableUsers: PropTypes.instanceOf(Array),
  update: PropTypes.func.isRequired,
};

Assignee.defaultProps = {
  assignee: [],
  assignableUsers: [],
};

export default Assignee;



// WEBPACK FOOTER //
// ./src/views/Components/Assignee.js